import { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import uniqid from "uniqid";
import { setFlipFlag, resetFlipFlagState } from "../redux/reducers/drmFlipFlagSlice";

const ALLOWED_FLIP_FLAG_STATUSES = new Set([11, 14]);

export const useFlipFlag = (dispatch, drmTableData, processId) => {
  const { t } = useTranslation();
  const [flipSnackbar, setFlipSnackbar] = useState({ message: "", severity: "", open: false });
  const { userInfo } = useSelector((state) => state.user);
  const {
    errorMessage = "",
    successMessage = "",
    isLoading = false,
  } = useSelector((state) => state?.drmFlipFlag || {});

  const handleFlipFlagConfirm = useCallback(() => {
    const selectedRows = drmTableData?.selectedRows || [];
    
    const isAllowed = selectedRows.every((row) =>
      ALLOWED_FLIP_FLAG_STATUSES.has(Number(row?.original?.status))
    );
    if (!isAllowed) {
      setFlipSnackbar({ message: t("flip_flag_not_allowed_message"), severity: "warning", open: true });
      return;
    }
    const sagaIds = selectedRows.map((row) => row?.original?.sagaId).filter(Boolean);
    dispatch(
      setFlipFlag({
        requestId: uniqid(),
        processId,
        sagaIds,
        userName: userInfo?.userName,
      })
    );
  }, [dispatch, drmTableData, processId, userInfo, t]);

  useEffect(() => {
    if (isLoading) return;
    if (successMessage) {
      setFlipSnackbar({ message: successMessage, severity: "info", open: true });
      dispatch(resetFlipFlagState());
    } else if (errorMessage) {
      setFlipSnackbar({ message: errorMessage, severity: "error", open: true });
      dispatch(resetFlipFlagState());
    }
  }, [isLoading, successMessage, errorMessage, dispatch]);

  const flipSnackClose = () => setFlipSnackbar({ message: "", severity: "", open: false });

  return { flipSnackbar, flipSnackClose, handleFlipFlagConfirm };
};
